import React, { useEffect, useRef, useState } from 'react';
import Mark from 'assets/images/lists/mark2.svg';
import cn from 'classnames';

import styles from './styles.scss';

const Select = ({ value, options, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref) {
      return;
    }
    const handleDocumentClick = (event) => {
      if (!ref.current.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [ref]);

  const handleClick = (selectedValue) => {
    if (value !== selectedValue) {
      onChange(selectedValue);
    }
    setIsOpen(false);
  };

  let selectedText = Object.keys(options).reduce((acc, key) => value == key ? options[key] : acc, '').slice(3);

  return (<div ref={ref} className={styles.Wrapper}>
    <div className={styles.Container}>
      <div onClick={() => setIsOpen(value => !value)} className={styles.Active}>
        На <span>{selectedText}</span>
        <img src={Mark} alt="" />
      </div>
      {isOpen && (
        <div className={styles.List}>
          {Object.keys(options).map(key => (
            <div
              onClick={() => handleClick(key)}
              key={key + options[key]}
              className={cn({ [styles.SelectedItem]: key == value })}
            >
              {options[key]}
            </div>
          ))}
        </div>
      )}
    </div>
  </div>);
};

export default React.memo(Select);



// WEBPACK FOOTER //
// ./src/containers/Rates/Select/index.js